<template>
    <div>
        <el-select v-model="mmm" filterable @change="handleChange" value-key="id">
            <el-option v-for="item in list_Product" :key="item.id" :label="item.productName" :value="item">
                <el-row type="flex" justify="space-between">
                    <span>{{ item.productName }}</span>
                    <span>{{ item.productType }}</span>
                </el-row>
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imageUrl: "",
            mmm: {id:2},

            list_Product: [
                { id: 1, productName: "产品1", productType: "类型1" },
                { id: 2, productName: "产品2", productType: "类型2" },
                { id: 3, productName: "产品3", productType: "类型3" }
            ]
        };
    },
    methods: {
        handleChange(v) {
            console.log(v);
        },
        test() {
            let that = this;
            that.axios.post("Test/ReceivePZDData1", {}).then((respose) => {
                console.log(respose);
                that.imageUrl = "data:image/png;base64," + respose.data;
            });
        }
    }
};
</script>
<style scoped>
.www200 {
    width: 200px;
}
</style>